import {FC, useState} from 'react'
import {useIntl} from 'react-intl'

import {PageTitle} from '_metronic/layout/core'

const SettingsPage: FC = () => {
  const intl = useIntl()
  const [settings, setSettings] = useState({notificationEmail: true, notificationSms: false})
  return (
    <div className='container-fluid'>
      <div className='card'>
        <div className='card-body'>
          <div className='row'>
            <div className='col-3 d-none d-lg-block'></div>
            <div className='col-md-12 col-lg-6'>
              <label
                className='form-check form-switch form-check-custom form-check-solid justify-content-between mb-5'
                htmlFor='kt_user_menu_dark_mode_toggle'
              >
                <span className='form-check-label me-3'>
                  {intl.formatMessage({id: 'SETTINGS.RECEIVE_NOTIFICATION_EMAIL'})}
                </span>
                <input
                  className='form-check-input'
                  type='checkbox'
                  name='notification'
                  id='kt_toggle_notification_email'
                  checked={settings.notificationEmail}
                  onChange={(e) => {
                    setSettings({...settings, notificationEmail: e.target.checked})
                  }}
                />
              </label>

              <label
                className='form-check form-switch form-check-custom form-check-solid justify-content-between mb-5'
                htmlFor='kt_user_menu_dark_mode_toggle'
              >
                <span className='form-check-label me-3'>
                  {intl.formatMessage({id: 'SETTINGS.RECEIVE_NOTIFICATION_SMS'})}
                </span>
                <input
                  className='form-check-input'
                  type='checkbox'
                  name='sms'
                  id='kt_toggle_notification_sms'
                  checked={settings.notificationSms}
                  onChange={(e) => {
                    console.log(e.target.checked)
                    setSettings({...settings, notificationSms: e.target.checked})
                  }}
                />
              </label>

              <button className='btn btn-sm btn-primary float-end'>
                {intl.formatMessage({id: 'GENERAL.SAVE'})}
              </button>
            </div>
            <div className='col-3 d-none d-lg-block'></div>
          </div>
        </div>
      </div>
    </div>
  )
}

const Settings: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.SETTINGS'})}</PageTitle>
      <SettingsPage />
    </>
  )
}

export {Settings}
